import { ICashFlowInvestingFLI } from './ICashFlowFLI.interface';

export interface ICashFlowInvestingActivitiesComponentInput {
    title: string;
    flis: ICashFlowInvestingFLI[];
    currentYearDate: string;
    previousYearDate: string;
    currency: string;
}
